import { createSelector } from 'reselect';

export const getState = (state) => state;

export const getLayout = createSelector(
  getState,
  (state) => state.layout
);
